import { render } from "./GameMain.vue?vue&type=template&id=2c5e927c&scoped=true"
import script from "./GameMain.vue?vue&type=script&lang=js"
export * from "./GameMain.vue?vue&type=script&lang=js"

import "./GameMain.vue?vue&type=style&index=0&id=2c5e927c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5e927c"]])

export default __exports__